import type {
  CartProductListItemDto,
  OrderDto,
  OrderListDto,
} from '@repo/api/web/models'
import { defineStore } from 'pinia'

export const useOrderStore = defineStore('order', () => {
  const currentOrder = ref<OrderDto | null>(null)
  const orders = ref<OrderListDto[]>([])
  const selectedItemsForOrder = ref<CartProductListItemDto[]>([])

  function setCurrentOrder(order: OrderDto | null) {
    currentOrder.value = order
  }

  function setSelectedItemsForOrder(items: CartProductListItemDto[]) {
    selectedItemsForOrder.value = items
  }

  function reset() {
    currentOrder.value = null
    orders.value = []
    selectedItemsForOrder.value = []
  }

  return {
    currentOrder,
    orders,
    selectedItemsForOrder,
    setCurrentOrder,
    setSelectedItemsForOrder,
    reset,
  }
})
